/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { ImageDialogButton } from "./image-dialog-button";
import { useTheme } from "@mui/material/styles";

const DefaultAddImageButton = (props) => {

    const theme = useTheme();

    const { setOpen } = props;

    return (
        <Fragment>
            <div
                style={{
                    width: "100%",
                    height: "96px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #CECECE",
                    borderRadius: "4px",
                    color: "#7A7A7A",
                    // padding: '12px',
                }}
            >
                <ImageDialogButton
                    setOpen={setOpen}
                    color={theme.palette.primary.main}
                />
            </div>
        </Fragment>
    );
};

export { DefaultAddImageButton };
